import type {
  GuardianControlName,
  GuardianControlState,
} from "@bw/shared/types/generated";

/**
 * Guardian activity controls (#2691): how each control reads to a guardian and
 * to a child. Only the five social controls exist, each Approve by default; the
 * server owns which controls exist and are enforced, this is presentation only.
 */
export const GUARDIAN_CONTROL_COPY: Record<
  GuardianControlName,
  { label: string; description: string }
> = {
  posting: {
    label: "Posts and comments",
    description: "Posting, commenting, liking and reposting in a community or on their profile.",
  },
  groups: {
    label: "Joining groups and channels",
    description: "Joining communities and creating channels.",
  },
  friends: {
    label: "Friend requests",
    description: "Sending and accepting friend requests, and following players.",
  },
  player_messages: {
    label: "Messages with other players",
    description: "Starting conversations and sending messages to other players.",
  },
  coach_messages: {
    label: "Messages with coaches and clubs",
    description: "Asking a club or coach a question and replying to them.",
  },
};

export const GUARDIAN_CHOICE_LABEL: Record<GuardianControlState, string> = {
  decline: "Decline",
  ask: "Ask",
  approve: "Approve",
};

/** What each choice means, shown under the choice a guardian picked. */
export const GUARDIAN_CHOICE_HELP: Record<GuardianControlState, string> = {
  decline: "They can't do this. The app tells them a guardian turned it off.",
  ask: "They ask first. Any guardian approves each new person or place once.",
  approve: "They can go ahead without asking.",
};

export function guardianControlLabel(control: GuardianControlName | null | undefined): string | null {
  return control ? GUARDIAN_CONTROL_COPY[control]?.label ?? null : null;
}
